import LocalizedInputCollection from './LocalizedInputCollection';

export default LocalizedInputCollection;
export * from './LocalizedInputCollection';
